import React from "react";
import HeaderOne from "../components/HeaderOne";
import FooterAreaOne from "../components/FooterAreaOne";
import CaseStudies from "../components/CaseStudies";

const CaseStudiesPage = () => {
  return (
    <>
      <HeaderOne />
      <CaseStudies />
      <FooterAreaOne />
    </>
  );
};

export default CaseStudiesPage;




















